"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _aemReactEditableComponents = require("@adobe/aem-react-editable-components");
var _core = require("@material-ui/core");
var _ExpandLess = _interopRequireDefault(require("@material-ui/icons/ExpandLess"));
var _ExpandMore = _interopRequireDefault(require("@material-ui/icons/ExpandMore"));
var _clsx = _interopRequireDefault(require("clsx"));
var _RichText = _interopRequireDefault(require("../RichText"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
var __jsx = _react.default.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useStyles = (0, _core.makeStyles)(function (theme) {
  return {
    heading: {
      marginTop: '0 !important'
    },
    captionStyle: {
      position: 'relative',
      paddingLeft: '0.8em',
      fontSize: '14px',
      lineHeight: '17px',
      marginBottom: '20px',
      textAlign: 'left',
      color: "".concat(theme.palette.common.black, " !important")
    },
    captionTitle: {
      fontWeight: 'bold',
      paddingRight: '0.4em'
    },
    tableStyle: {
      width: '100%',
      marginTop: '0',
      marginBottom: '8px'
    },
    cell: function cell(props) {
      return {
        padding: '16px 24px',
        verticalAlign: 'middle',
        borderTop: props.verticalTable ? '' : "1px solid ".concat(theme.palette.grey[300]),
        borderRight: props.verticalTable && "1px solid ".concat(theme.palette.grey[300]),
        borderBottom: props.verticalTable && 'none'
      };
    },
    header: function header(props) {
      return {
        backgroundColor: 'whitesmoke',
        fontWeight: 900,
        color: 'black',
        borderTop: props.verticalTable ? '' : "1px solid ".concat(theme.palette.grey[300]),
        fontSize: '12px',
        '.MuiCollapse-wrapper &': {
          backgroundColor: theme.palette.background.default
        },
        borderLeft: props.verticalTable && "1px solid ".concat(theme.palette.grey[300]),
        borderRight: props.verticalTable && "1px solid ".concat(theme.palette.grey[300]),
        borderBottom: props.verticalTable && 'none'
      };
    },
    headerTitle: {
      padding: 0,
      border: 0
    },
    headerWrapper: {
      display: 'inline-flex',
      alignItems: 'center',
      position: 'relative',
      cursor: 'pointer'
    },
    sortIcon: {
      color: theme.palette.primary.main,
      position: 'absolute',
      right: '-24px'
    }
  };
});
var cleanStyles = function cleanStyles(original) {
  var clean = {};
  original && Object.keys(original).forEach(function (key) {
    if (isNaN(Number(key)) && original[key] !== '') {
      clean[key] = original[key];
    }
  });
  return clean;
};
var createCellFromHTML = function createCellFromHTML(htmlCell) {
  return {
    content: htmlCell.innerHTML,
    header: htmlCell.tagName === 'TH',
    attributes: {
      colSpan: htmlCell.colSpan,
      rowSpan: htmlCell.rowSpan,
      style: _objectSpread(_objectSpread({}, cleanStyles(htmlCell.style)), {}, {
        textAlign: htmlCell.align || htmlCell.style.textAlign,
        backgroundColor: htmlCell.bgColor || htmlCell.style.backgroundColor,
        width: htmlCell.width || htmlCell.style.width,
        height: htmlCell.height || htmlCell.style.height,
        verticalAlign: htmlCell.vAlign || htmlCell.style.verticalAlign
      })
    }
  };
};
var rowSort = function rowSort(columnIndex) {
  return function (rowA, rowB) {
    var _rowA$columnIndex, _rowB$columnIndex;
    var rowAValue = ((_rowA$columnIndex = rowA[columnIndex]) === null || _rowA$columnIndex === void 0 ? void 0 : _rowA$columnIndex.content) || '';
    var rowBValue = ((_rowB$columnIndex = rowB[columnIndex]) === null || _rowB$columnIndex === void 0 ? void 0 : _rowB$columnIndex.content) || '';
    if (!isNaN(Number(rowAValue)) && !isNaN(Number(rowBValue))) return Number(rowAValue) - Number(rowBValue);else return rowAValue.localeCompare(rowBValue);
  };
};
var SortableTable = function SortableTable(props) {
  var _rows$;
  var table = props.table,
    title = props.title,
    caption = props.caption,
    anchorId = props.anchorId,
    headline = props.headline,
    _props$enableSort = props.enableSort,
    enableSort = _props$enableSort === void 0 ? false : _props$enableSort,
    _props$verticalTable = props.verticalTable,
    verticalTable = _props$verticalTable === void 0 ? false : _props$verticalTable;
  var _useState = (0, _react.useState)([]),
    sortHeader = _useState[0],
    updateSortHeader = _useState[1];
  var _useState2 = (0, _react.useState)([]),
    rows = _useState2[0],
    updateRows = _useState2[1];
  var _useState3 = (0, _react.useState)({
      column: -1,
      ascending: true
    }),
    sortState = _useState3[0],
    updateSortState = _useState3[1];
  var classes = useStyles({
    verticalTable: verticalTable
  });
  var sortOnColumn = function sortOnColumn(columnIndex) {
    if (sortState.column === columnIndex) {
      updateRows(Array.from(rows).reverse());
      updateSortState({
        column: columnIndex,
        ascending: !sortState.ascending
      });
    } else {
      rows.sort(rowSort(columnIndex));
      updateRows(Array.from(rows));
      updateSortState({
        column: columnIndex,
        ascending: true
      });
    }
  };
  (0, _react.useEffect)(function () {
    if (!table) {
      return;
    }
    var div = document.createElement('div');
    div.innerHTML = table;
    var tableElement = div.getElementsByTagName('table').item(0);
    if (tableElement) {
      var tableRows = Array.from(tableElement.rows);
      var cellRows = tableRows.map(function (row) {
        return Array.from(row.cells).map(createCellFromHTML);
      });
      if (enableSort &&
      // Global sort enabled
      !cellRows.some(function (cells) {
        return cells.some(function (cell) {
          return cell.attributes.colSpan > 1 || cell.attributes.rowSpan > 1;
        });
      }) &&
      // No Spans
      cellRows.length > 2 &&
      // More than one data row
      cellRows[0].every(function (cell) {
        return cell.header;
      }) // All cells in first row are headers
      ) {
        updateSortHeader(cellRows.shift());
      } else {
        updateSortHeader([]);
      }
      updateRows(cellRows);
    }
  }, [table, enableSort]);
  if (!table) return null;
  var colSpan = (sortHeader === null || sortHeader === void 0 ? void 0 : sortHeader.length) || ((_rows$ = rows[0]) === null || _rows$ === void 0 ? void 0 : _rows$.length) || 1;
  return __jsx("div", {
    id: anchorId,
    className: "aem-ms-cmp aem-ms-sortable-table"
  }, __jsx(_core.Table, {
    className: classes.tableStyle
  }, (headline || sortHeader) && __jsx(_core.TableHead, null, headline && __jsx(_core.TableRow, null, __jsx(_core.TableCell, {
    className: classes.headerTitle,
    component: 'th',
    colSpan: colSpan
  }, __jsx("h3", {
    className: classes.heading,
    dangerouslySetInnerHTML: {
      __html: headline
    }
  }))), sortHeader && __jsx(_core.TableRow, null, sortHeader.map(function (cell, columnIndex) {
    return __jsx(_core.TableCell, (0, _extends2.default)({
      key: "header-".concat(columnIndex),
      className: (0, _clsx.default)(classes.cell, classes.header),
      component: 'th'
    }, cell.attributes), __jsx("div", {
      className: classes.headerWrapper,
      onClick: function onClick() {
        return sortOnColumn(columnIndex);
      }
    }, __jsx("span", {
      dangerouslySetInnerHTML: {
        __html: cell.content.toString()
      }
    }), sortState.column === columnIndex && (sortState.ascending ? __jsx(_ExpandMore.default, {
      className: classes.sortIcon
    }) : __jsx(_ExpandLess.default, {
      className: classes.sortIcon
    }))));
  }))), __jsx(_core.TableBody, null, rows.map(function (row, rowIndex) {
    return __jsx(_core.TableRow, {
      key: "row-".concat(rowIndex)
    }, row.map(function (cell, cellIndex) {
      return __jsx(_core.TableCell, (0, _extends2.default)({
        key: "row-".concat(rowIndex, "-cell-").concat(cellIndex),
        component: cell.header ? 'th' : 'td'
      }, cell.attributes, {
        className: (0, _clsx.default)(classes.cell, cell.header && classes.header)
      }), __jsx(_RichText.default, {
        text: cell.content.toString()
      }));
    }));
  })), (title || caption) && __jsx("caption", {
    className: classes.captionStyle
  }, title && __jsx("span", {
    className: classes.captionTitle,
    dangerouslySetInnerHTML: {
      __html: title
    }
  }), caption && __jsx("span", {
    dangerouslySetInnerHTML: {
      __html: caption
    }
  }))));
};
var tableEditConfig = {
  emptyLabel: 'Static Table',
  isEmpty: function isEmpty(props) {
    if (!props.table) {
      return true;
    } else {
      return false;
    }
  }
};
var _default = (0, _aemReactEditableComponents.MapTo)('cms-commons/components/content/table')(SortableTable, tableEditConfig);
exports.default = _default;